import React from "react";
import { FilterLabelProps, BaseInputFieldFilter } from "@duosoftbg/nacid-components";

const UniversityCountryNameFilter = ({ label = "l.searchFilter.country", ...others }: FilterLabelProps) => {
  return (
    <>
      <BaseInputFieldFilter sm={6} md={3} fieldName={"universityCountryName"} label={label} {...others} />
    </>
  );
};

export default UniversityCountryNameFilter;
